function ChartIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
    >
      <g opacity="0.5">
        <path
          d="M32.0832 32.0827H17.4998C10.6253 32.0827 7.18796 32.0827 5.0515 29.9462C2.9165 27.8127 2.9165 24.3739 2.9165 17.4993V2.91602"
          stroke="url(#paint0_linear_1725_5683)"
          stroke-width="2.1875"
          stroke-linecap="round"
        />
        <path
          d="M32.0832 32.0827H17.4998C10.6253 32.0827 7.18796 32.0827 5.0515 29.9462C2.9165 27.8127 2.9165 24.3739 2.9165 17.4993V2.91602"
          stroke="black"
          stroke-opacity="0.2"
          stroke-width="2.1875"
          stroke-linecap="round"
        />
      </g>
      <path
        d="M27.7083 10.208L23.1613 15.9334C22.4656 16.8113 22.1171 17.2503 21.7175 17.4647C21.4142 17.6268 21.0769 17.7151 20.7331 17.7225C20.3892 17.7298 20.0485 17.656 19.7385 17.507C19.3302 17.3101 18.9642 16.8872 18.2292 16.0413C17.4942 15.1955 17.1281 14.7726 16.7198 14.5757C16.4099 14.4272 16.0694 14.3537 15.7258 14.3613C15.3822 14.3689 15.0453 14.4574 14.7423 14.6195C14.3427 14.8324 13.9942 15.2713 13.2985 16.1478L8.75 21.8747"
        stroke="url(#paint1_linear_1725_5683)"
        stroke-width="2.1875"
        stroke-linecap="round"
      />
      <path
        d="M27.7083 10.208L23.1613 15.9334C22.4656 16.8113 22.1171 17.2503 21.7175 17.4647C21.4142 17.6268 21.0769 17.7151 20.7331 17.7225C20.3892 17.7298 20.0485 17.656 19.7385 17.507C19.3302 17.3101 18.9642 16.8872 18.2292 16.0413C17.4942 15.1955 17.1281 14.7726 16.7198 14.5757C16.4099 14.4272 16.0694 14.3537 15.7258 14.3613C15.3822 14.3689 15.0453 14.4574 14.7423 14.6195C14.3427 14.8324 13.9942 15.2713 13.2985 16.1478L8.75 21.8747"
        stroke="black"
        stroke-opacity="0.2"
        stroke-width="2.1875"
        stroke-linecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1725_5683"
          x1="2.9165"
          y1="-6.45898"
          x2="38.7716"
          y2="-1.23247"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1725_5683"
          x1="8.75"
          y1="6.45801"
          x2="31.2865"
          y2="11.7963"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default ChartIcon;
